/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import * as React from 'react';

import IconButton from '@mui/material/IconButton';

import TableCell from '@mui/material/TableCell';

import TableRow from '@mui/material/TableRow';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useCallback } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import uuid from 'react-uuid';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import { getAnswerListStyle, getItemStyle } from '../../../../utils';
import { useTableDataContext } from '../../../context/EditingTableDataContext';
import { useRowExpansion } from '../../../hooks/useRowExpansion';
import { SecondLayer } from './SecondLayer';

import { columns } from '../../../utils';
import { ActionsCell } from './ActionsCell';

export const FirstLayerRow = ({
  itemNum,
  description,
  unit,
  quantity,
  unitPrice,
  price,
  isFinished,
  firstLayerIndex,
}) => {
  const { allTableDataWithExtraInfo, updateTableData, setToaster } =
    useTableDataContext();

  const { isRowExpanded, toggleRowExpansion } =
    useRowExpansion(firstLayerIndex);

  const currentFirstLayerArrayData = React.useMemo(
    () => allTableDataWithExtraInfo.items_attributes[firstLayerIndex],
    [allTableDataWithExtraInfo.items_attributes, firstLayerIndex]
  );

  const hasSubitems = !!currentFirstLayerArrayData.items_attributes.length;
  const canHaveSubItems = !unitPrice && !quantity && !unit;
  const addNewRowSecondLayer = useCallback(() => {
    const newState = { ...allTableDataWithExtraInfo };
    newState.items_attributes[firstLayerIndex].items_attributes.push({
      item_num: `${allTableDataWithExtraInfo.items_attributes[firstLayerIndex].items_attributes.length + 1}`,
      description: '',
      unity: '',
      quantity: '',
      unit_price: 0,
      price: 0,
      items_attributes: [],
      id: null,
    });

    updateTableData(newState);
  }, [allTableDataWithExtraInfo, firstLayerIndex, updateTableData]);

  const subItemHasPayables = (items) => {
    const hasPayables = [];

    items.forEach((item) => {
      if (item.items_attributes.length) {
        item.items_attributes.forEach((subItem) => {
          hasPayables.push(subItem.has_payables);
        });
      }
      hasPayables.push(item.has_payables);
    });

    return hasPayables.some((item) => item);
  };

  const deleteRowFromFromSubLayer = useCallback(() => {
    const selectedItem =
      allTableDataWithExtraInfo.items_attributes[firstLayerIndex];

    if (
      selectedItem.has_payables ||
      subItemHasPayables(selectedItem.items_attributes)
    ) {
      setToaster({
        open: true,
        msg: 'Este item possui lançamentos associados e não pode ser excluído. Edite os lançamentos para remover a associação antes de excluir este item.',
      });
      setTimeout(() => setToaster({ open: false, msg: '' }), 5000);
    } else {
      const newState = allTableDataWithExtraInfo.items_attributes
        .filter((_item, i) => firstLayerIndex !== i)
        .map((item, idx) => ({
          ...item,
          item_num: `${idx + 1}`,
        }));
      updateTableData({
        ...allTableDataWithExtraInfo,
        items_attributes: newState,
      });
    }
  }, [allTableDataWithExtraInfo, firstLayerIndex, updateTableData]);

  const updateFirstLayerFieldHandler = (e, idx) => {
    const newState = [...allTableDataWithExtraInfo.items_attributes];
    const { name, value, checked } = e.target;

    let valueToFormat = value;

    if (name === 'unit_price') {
      const numericValue = value.replace(/\D/g, '').replace(',', '.') || '0';
      const floatValue = parseFloat(numericValue) / 100;
      valueToFormat = floatValue;
    }

    if (name === 'quantity') {
      valueToFormat = value.replace(/[^0-9.,]/g, '');
    }

    newState[idx][name] = name === 'is_finalized' ? checked : valueToFormat;

    if (name === 'quantity' || name === 'unit_price') {
      const quantityFirstLayer =
        (typeof newState[idx].quantity === 'string'
          ? newState[idx].quantity.replace(',', '.')
          : newState[idx].quantity) ?? '0';
      const unitPriceFirstLayer = newState[idx].unit_price || 0;
      const totalPrice = Number(quantityFirstLayer) * unitPriceFirstLayer;
      newState[idx].price = totalPrice;
    }

    updateTableData({
      ...allTableDataWithExtraInfo,
      items_attributes: newState,
    });
  };

  const generateTableCell = ({ editable, align, data, id }) => {
    if (
      hasSubitems &&
      (id === 'unit' ||
        id === 'quantity' ||
        id === 'unit_price' ||
        id === 'is_finalized')
    ) {
      return (
        <TableCell
          sx={{ cursor: 'pointer' }}
          onClick={() => toggleRowExpansion((old) => !old)}
        />
      );
    }

    if (id === 'is_finalized') {
      return (
        <TableCell
          onClick={
            hasSubitems && !editable
              ? () => toggleRowExpansion((old) => !old)
              : undefined
          }
          align={align}
        >
          <Checkbox
            sx={{ m: 'auto' }}
            name={id}
            checked={data}
            onChange={(e) => updateFirstLayerFieldHandler(e, firstLayerIndex)}
            color="default"
          />
        </TableCell>
      );
    }

    if (!editable) {
      return (
        <TableCell
          onClick={
            hasSubitems && !editable
              ? () => toggleRowExpansion((old) => !old)
              : undefined
          }
          align={align}
          sx={{ cursor: hasSubitems && !editable ? 'pointer' : 'initial' }}
        >
          {id === 'item_num'
            ? data
            : data.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
        </TableCell>
      );
    }

    let value = data;

    if (id === 'unit_price') {
      value = value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    if (id === 'quantity' && typeof value === 'string') {
      value = value.replace(/\./g, ',');
    }

    return (
      <TableCell
        onClick={
          hasSubitems && !editable
            ? () => toggleRowExpansion((old) => !old)
            : undefined
        }
        align={align}
        sx={{ cursor: hasSubitems && !editable ? 'pointer' : 'initial' }}
      >
        <input
          name={id}
          style={{
            outline: 0,
            border: '0 none',
            fontFamily: 'montserrat',
            background: 'none',
            width: '100%',
            textAlign: align,
          }}
          placeholder="Insira o dado"
          value={value}
          onChange={(e) => updateFirstLayerFieldHandler(e, firstLayerIndex)}
        />
      </TableCell>
    );
  };

  return (
    <Draggable draggableId={itemNum} index={firstLayerIndex}>
      {(provided, snapshot) => (
        <>
          <TableRow
            sx={{
              '& > *': {
                borderBottom: 'unset',
              },
            }}
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
            className="primary-item"
          >
            <TableCell
              onClick={
                hasSubitems
                  ? () => toggleRowExpansion((old) => !old)
                  : undefined
              }
              sx={{ cursor: hasSubitems ? 'pointer' : '' }}
            >
              {hasSubitems ? (
                <IconButton size="small">
                  {isRowExpanded ? (
                    <KeyboardArrowUpIcon style={{ fontSize: '14px' }} />
                  ) : (
                    <KeyboardArrowDownIcon style={{ fontSize: '14px' }} />
                  )}
                </IconButton>
              ) : (
                <div style={{ width: '5px', marginLeft: '9px' }} />
              )}
            </TableCell>
            {generateTableCell({
              data: itemNum,
              align: 'left',
              id: 'item_num',
            })}
            {generateTableCell({
              data: description,
              align: 'left',
              editable: true,
              id: 'description',
            })}
            {generateTableCell({
              data: unit,
              align: 'center',
              editable: !hasSubitems,
              id: 'unit',
            })}
            {generateTableCell({
              data: quantity,
              align: 'center',
              editable: !hasSubitems,
              id: 'quantity',
            })}
            {generateTableCell({
              data: unitPrice,
              align: 'center',
              editable: !hasSubitems,
              id: 'unit_price',
            })}
            {generateTableCell({
              data: price,
              align: 'center',
              id: 'price',
            })}
            {generateTableCell({
              data: isFinished,
              align: 'center',
              id: 'is_finalized',
            })}
            <ActionsCell
              canHaveSubItems={canHaveSubItems}
              addNewItemToSubLayer={() => {
                addNewRowSecondLayer();
                toggleRowExpansion(true);
              }}
              provided={provided}
              deleteRowFromCurrentLayer={deleteRowFromFromSubLayer}
              addNewItemSubLayerIconStyle={{
                cursor: hasSubitems ? 'pointer' : 'default',
              }}
              dragIconStyle={{
                cursor: 'inherit',
                fontSize: '18px',
                marginTop: '15px',
              }}
              deleteIconStyle={{
                cursor: 'pointer',
                color: 'red',
              }}
            />
          </TableRow>

          {/* SECOND LAYER / SECOND TABLE */}
          {hasSubitems && (
            <Droppable
              droppableId={`droppable-${itemNum}`}
              type={`${firstLayerIndex}`}
            >
              {/* eslint-disable-next-line no-shadow */}
              {(provided, snapshot) => (
                <TableRow
                  ref={provided.innerRef}
                  style={getAnswerListStyle(snapshot.isDraggingOver)}
                  className="secondary-item"
                >
                  <TableCell align="center" style={{ padding: 0 }} colSpan={12}>
                    <Collapse in={isRowExpanded} timeout="auto" unmountOnExit>
                      <Box sx={{ margin: 1 }}>
                        <Typography variant="h6" gutterBottom component="div" />
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: '40px' }} />
                              {columns.map((column) => (
                                <TableCell
                                  key={uuid()}
                                  align={column.align}
                                  sx={{
                                    width: column.width,
                                    fontSize: '12px',
                                    fontWeight: 700,
                                  }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allTableDataWithExtraInfo.items_attributes[
                              firstLayerIndex
                            ].items_attributes.map(
                              (secondLayerItem, secondLayerIndex) => (
                                <SecondLayer
                                  key={secondLayerItem.item_num}
                                  firstLayerItemNum={itemNum}
                                  firstLayerIndex={firstLayerIndex}
                                  secondLayerItemNum={secondLayerItem.item_num}
                                  secondLayerDescription={
                                    secondLayerItem.description
                                  }
                                  secondLayerUnit={secondLayerItem.unit}
                                  secondLayerQuantity={secondLayerItem.quantity}
                                  secondLayerUnitPrice={
                                    secondLayerItem.unit_price
                                  }
                                  secondLayerPrice={secondLayerItem.price}
                                  secondLayerFinalized={
                                    secondLayerItem.is_finalized
                                  }
                                  secondLayerIndex={secondLayerIndex}
                                />
                              )
                            )}
                            {provided.placeholder}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              )}
            </Droppable>
          )}
        </>
      )}
    </Draggable>
  );
};

FirstLayerRow.propTypes = {
  firstLayerIndex: PropTypes.number.isRequired,
  itemNum: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  unitPrice: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
};
